function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o, p);
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { Component } from "react";
import Input from "../../../../input";
import styled from "styled-components";
import { connect as connectFormik, getIn } from "formik";
import { SmallText, MutedText } from "../../../../text";
import Label from "../../../../label";
import memoizeOne from "memoize-one";
import { getLocalizedProperty } from "../../../../../utils/i18n";
import { context } from "../../../../../components/wr-context";
var getQuantityValue = memoizeOne(function(values) {
    return (Object.entries(values).find(function(param) {
        var _param = _slicedToArray(param, 1), k = _param[0];
        return k.includes("Quantity");
    }) || [])[1];
});
var InputContainer = styled.div(_templateObject());
var TextComponent = /*#__PURE__*/ function(Component) {
    "use strict";
    _inherits(TextComponent, Component);
    var _super = _createSuper(TextComponent);
    function TextComponent() {
        _classCallCheck(this, TextComponent);
        return _super.apply(this, arguments);
    }
    var _proto = TextComponent.prototype;
    _proto.render = function render() {
        var ref, ref1, ref2, ref3, ref4, ref5;
        var _props = this.props, row = _props.row, formik = _props.formik, product = _props.product, hideLabel = _props.hideLabel, disabled = _props.disabled;
        var name = row.id;
        var value = getIn(formik.values, name);
        var error = getIn(formik.errors, name);
        var touched = getIn(formik.touched, name);
        var rowLabel = getLocalizedProperty(row, "label");
        var label = ((ref = row.options) === null || ref === void 0 ? void 0 : ref.isRequired) ? "* ".concat(rowLabel) : rowLabel;
        var helpText = this.props.allowHelpText ? row.description : "";
        var hasQuestionnaire = (ref1 = row.options) === null || ref1 === void 0 ? void 0 : ref1.hasQuestionnaire;
        if (!hasQuestionnaire) {
            var val = row.control;
            if (row.description === "Display on the Details Page Only") {
                return null;
            }
            if (val && typeof val !== "string") {
                val = val.toString();
            }
            if (val && val.trim().length !== 0) {
                return /*#__PURE__*/ React.createElement("div", null, /*#__PURE__*/ React.createElement(Label, null, label.replace("[CUSTOMER FACING]", "")), helpText && /*#__PURE__*/ React.createElement(MutedText, null, helpText), /*#__PURE__*/ React.createElement("div", null, val));
            }
            return null;
        }
        var isTextArea = row.rowType === "free-text";
        return /*#__PURE__*/ React.createElement(InputContainer, null, /*#__PURE__*/ React.createElement(Input, {
            onChange: formik.handleChange,
            onBlur: formik.handleBlur,
            onKeyPress: isTextArea ? function(ev) {
                ev.stopPropagation();
            } : undefined,
            hideLabel: hideLabel,
            value: value,
            name: name,
            error: touched && error,
            label: label,
            disabled: ((ref2 = row.options) === null || ref2 === void 0 ? void 0 : ref2.readOnly) || disabled,
            hintText: row.description,
            textArea: isTextArea,
            type: ((ref3 = row.options) === null || ref3 === void 0 ? void 0 : ref3.inputType) === "numeric" ? "number" : "text",
            rows: (ref4 = context.theme.components) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.textArea) === null || ref5 === void 0 ? void 0 : ref5.rows
        }), row.label === "Sales Price" && value && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(SmallText, {
            style: {
                marginLeft: "1rem"
            }
        }, 100 - Math.min(100, Math.round(value / ((product.serviceRateCents || 0) / 100) * 100)), "% discount"), (getQuantityValue(formik.values) || 0) > 1 && /*#__PURE__*/ React.createElement("div", {
            style: {
                marginTop: "0.6rem"
            }
        }, /*#__PURE__*/ React.createElement("span", null, "Total: $", (value * getQuantityValue(formik.values)).toLocaleString()))));
    };
    TextComponent.shouldComponentUpdate = function shouldComponentUpdate(nextProps, props) {
        var nextFormik = nextProps.formik, nextDisabled = nextProps.disabled;
        var formik = props.formik, disabled = props.disabled;
        var name = props.row.id;
        return getIn(formik.values, name) !== getIn(nextFormik.values, name) || getIn(formik.errors, name) !== getIn(nextFormik.errors, name) || getIn(formik.touched, name) !== getIn(nextFormik.touched, name) || disabled !== nextDisabled;
    };
    return TextComponent;
}(Component);
export default connectFormik(TextComponent);
